import React, { useContext, useEffect, useState } from "react";

import {
	IconContainer,
	Logo,
	MainHeaderContainer,
	Container,
	DropdownOverlay,
	HeaderUserInfo,
	ToggleButton,
} from "./styles";

import HeaderDropdown from "./HeaderDropdown";
import logoImg from "../../assets/images/logo.svg";
import { Link } from "react-router-dom";
import { getUserInfo } from "../../services/userService";
import { IUserInfo } from "./constants";
import { Flex } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { SidebarContext } from "../../context/SidebarMenuProvider";

const MainHeader: React.FC = () => {
	const { isSidebarOpen, toggleSidebar } = useContext(SidebarContext);

	const [userData, setUser] = useState<IUserInfo>({
		name: "",
		surname: "",
		profilePhoto: "",
	});

	useEffect(() => {
		const fetchUserInfo = async () => {
			const data = await getUserInfo();

			setUser({ ...data });
		};

		fetchUserInfo();
	}, []);

	const [isDropdownActive, setIsDropdownActive] = useState<boolean>(false);
	const [showOverlay, setShowOverlay] = useState<boolean>(false);

	const setDropdownStatus = (
		event:
			| React.MouseEvent<HTMLElement>
			| React.MouseEvent<SVGSVGElement, MouseEvent>
	) => {
		event.preventDefault();

		setIsDropdownActive(!isDropdownActive);
	};

	const hideOverlay = (
		event:
			| React.MouseEvent<HTMLElement>
			| React.MouseEvent<SVGSVGElement, MouseEvent>
	) => {
		event.stopPropagation();

		setShowOverlay(false);
	};

	const handleOverlay = (event: React.MouseEvent<HTMLElement>) => {
		event.stopPropagation();

		setDropdownStatus(event);

		hideOverlay(event);
	};

	return (
		<MainHeaderContainer>
			<Container id="header-container">
				{showOverlay && <DropdownOverlay onClick={handleOverlay} />}
				<Flex justify="space-between" align="center" gap={15}>
					<ToggleButton onClick={toggleSidebar}>
						{isSidebarOpen ? <MenuUnfoldOutlined style={{ color: '#fff' }} /> : <MenuFoldOutlined style={{ color: '#fff' }} />}
					</ToggleButton>
					<Link to="/">
						<Logo src={logoImg} alt="kochr" />
					</Link>
				</Flex>
				<HeaderUserInfo>
					<div style={{ fontSize: "20px" }}>
						<div style={{ textAlign: "right" }}>
							Merhaba{" "}
							{
								userData?.name && userData.name.length > 15
									? userData.name.split(" ")[0]
									: userData.name
							}!
						</div>
					</div>
					<IconContainer id="header-dropdown">
						<HeaderDropdown
							userData={userData}
							hideOverlay={hideOverlay}
							showOverlay={showOverlay}
							setShowOverlay={setShowOverlay}
							setDropdownStatus={setDropdownStatus}
							isDropdownActive={isDropdownActive}
						/>
					</IconContainer>
				</HeaderUserInfo>
			</Container>
		</MainHeaderContainer>
	);
};

export default MainHeader;
